<app-previewable [locked]="locked" [previewImage]="image" [previewTitle]="title" *transloco="let t">
  <figure>
    <a *ngIf="url" [href]="materialServer + url" class="download" target="_blank">
      <div (click)="downloadMaterialInAndroid($event, materialServer + url)">{{ t('shared/download') }}</div>
      <div (click)="downloadMaterialInAndroid($event, materialServer + url)"><i aria-hidden="true" [class]="iconService.download"></i></div>
    </a>
    <img src="{{ materialServer + image }}" alt="{{ title }}" />
  </figure>
</app-previewable>
